// extracted by mini-css-extract-plugin
module.exports = {"mt40px":"Divider_mt40px__nw6M9","mb40px":"Divider_mb40px__ibMP4","mt0":"Divider_mt0__MXxQO","mb0":"Divider_mb0__m5eka","opacity0":"Divider_opacity0__BgFqW"};